export const logEvent = (eventName: string, data: Record<string, any>) => {
  console.log(`[Analytics] ${eventName}:`, data);
};
